import axios from "axios"

export const adminFeedbackRequest = new Request('/api/oracle2/getfeedback' ,{method: 'GET'})

const baseURL = window.localStorage.getItem('BASE_URL')

const mapboxtoken = process.env.REACT_APP_MAPBOXAPI

export const accountLoader = async (email) =>{ 
    
     return await fetch(baseURL + '/api/oracle3/getaccounts',{method: 'POST', headers:{
        'Content-Type': 'application/json'
     }, body: JSON.stringify({email: email})})}

export const confirmationLoader= async (customer_number) =>{
   return await fetch(baseURL + '/api/oracle1/confirmation',{method: 'POST', headers:{
      'Content-Type': 'application/json'
   }, body: JSON.stringify({customer_number: customer_number})})

}

export const waveAccountLoader = async (email) => {
   return await fetch(baseURL + '/api/oracle2/getwaveid',{method: 'POST', headers:{'Content-Type': 'application/json'}, 
                     body: JSON.stringify({email: email}) })
}

export const getPlaces = async (query) =>{
try{
   
   const response = await axios.get(
      `https://api.mapbox.com/geocoding/v5/mapbox.places/${query}.json`,
      {
         params: {access_token: mapboxtoken,
                  country: "US"
         },
      },
   );
   
   return response.data.features
}
catch(error){
   console.error("There was an error while fetching places: ", error)
}

}

export const recurringPayments = new Request('/api/oracle2/getreccuringpayments' ,{method: 'GET'})



